import {MinzeElement} from "minze";

export interface TjImportantMessages {
  dataGroupId: string,
}

export class TjImportantMessages extends MinzeElement {
  attrs = ["data-group-id"];
  onReady() {
    const mainModule = window.TJ_MAIN_MODULE;
    mainModule.loadImportantMessages(this.dataGroupId);
  }
}